import ApiCall from '../utils/axiousCall2';
import publicApiCall from '../utils/publicAxiosCall';
// import { baseURL } from '../utils/publicAxiosCall2';
import { errorToast, successToast } from '../utils/toast';
const baseURL = `${process.env.NEXT_PUBLIC_BASE_URL_DEV}/api`;

const verifyEmail =
  ({ token, navigate }) =>
    (dispatch) => {
      console.log(token);
      publicApiCall
        .post(
          'user/verify-email',
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((res) => {
          successToast(res.data.message);
          navigate('/');
        })
        .catch((err) => {
          navigate('/');
          errorToast(err?.response?.data.message);
        });
    };

const recoverPassword = (data, token, navigate) => async (dispatch) => {
  console.log(token, data);
  try {
    console.log("data is ", data);
    document.getElementById('overlay').style.display = 'block';
    const response = await fetch(`${baseURL}/user/password/recover-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,

      },
      body: JSON.stringify(data),
    });
    console.log("respo = ", response);
    if (!response.ok) {
      const errorData = await response.json();
      errorToast(errorData.message);
      document.getElementById('overlay').style.display = 'none';
      if (window.location.pathname === '/recover-password') navigate('/');
      return;
    }

    const resData = await response.json();
    successToast(resData.message);
    document.getElementById('overlay').style.display = 'none';

    navigate('/login');

  } catch (error) {
    // Dispatch your error action if using Redux
    // dispatch();
    console.error('An error occurred while making the request:', error);
    errorToast('An error occurred while making the request.');
  }
  // publicApiCall
  //   .post('user/password/recover-password', data, {
  //     headers: {
  //       Authorization: token,
  //     },
  //   })
  //   .then((res) => {
  //     successToast(res.data.message);
  //     navigate('/login');
  //   })
  //   .catch((err) => {
  //     errorToast(err?.response?.data.message);
  //   });
};
// const recoverPasswordUsingEmail = (data, navigate) => (dispatch) => {
//   publicApiCall
//     .post('user/password/recover/email', data)
//     .then((res) => {
//       successToast(res.data.message);
//       navigate(
//         `${
//           window.location.pathname === '/reset-credential-verification'
//             ? `/enter-verification-code?email=${data.email}&token=${res.data.magicLinkToken}`
//             : `${window.location.pathname}?email=${data.email}&token=${res.data.magicLinkToken}`
//         }`
//       );
//     })
//     .catch((err) => {
//       errorToast(err?.response?.data.message);
//     });
// };
const recoverPasswordUsingEmail = (data, navigate) => async (dispatch) => {
  try {
     console.log("data is ", data);
    document.getElementById('overlay').style.display = 'block';
    const response = await fetch(`${baseURL}/user/password/recover/email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    console.log("respo = ", response);
    if (!response.ok) {
      const errorData = await response.json();
      // Dispatch your error action if using Redux
      // dispatch();
      errorToast(errorData.message);
      document.getElementById('overlay').style.display = 'none';

      return;
    }

    const resData = await response.json();
    successToast(resData.message);
    document.getElementById('overlay').style.display = 'none';

    navigate(
      `${window.location.pathname === '/forget-password'
        ? `/otp-validation?email=${data.email}&token=${resData.magicLinkToken}`
        : `${window.location.pathname}?email=${data.email}&token=${resData.magicLinkToken}`
      }`
    );
  } catch (error) {
    // Dispatch your error action if using Redux
    // dispatch();
    console.error('An error occurred while making the request:', error);
   // errorToast('An error occurred while making the request.');
  }
};

const verifyOtp = (data, token, navigate) => async (dispatch) => {
  console.log(token, data);
  try {
    console.log("data is ", data);
    document.getElementById('overlay').style.display = 'block';
    const response = await fetch(`${baseURL}/user/password/verify-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,

      },
      body: JSON.stringify(data),
    });
    console.log("respo = ", response);
    if (!response.ok) {
      const errorData = await response.json();
      errorToast(errorData.message);
      document.getElementById('overlay').style.display = 'none';
      if (window.location.pathname === '/recover-password') navigate('/');
      return;
    }

    const resData = await response.json();
    successToast(resData.message);
    document.getElementById('overlay').style.display = 'none';

    navigate(`/change-password?token=${res.data?.recoveryToken}`);

  } catch (error) {
    // Dispatch your error action if using Redux
    // dispatch();
    console.error('An error occurred while making the request:', error);
    errorToast('An error occurred while making the request.');
  }
  // publicApiCall
  //   .post('user/password/verify-otp', data, {
  //     headers: {
  //       Authorization: token,
  //     },
  //   })
  //   .then((res) => {
  //     console.log("res = ",res);
  //     successToast(res.data.message);
  //     navigate(`/password-reset?token=${res.data?.recoveryToken}`);
  //   })
  //   .catch((err) => {
  //     console.log("error = ",err);
  //     errorToast(err?.response.data?.message);
  //     if (window.location.pathname === '/recover-password') navigate('/');
  //   });
};

const resendVerification = (email) => (dispatch) => {
  publicApiCall
    .post('user/verify-registered-email', { email })
    .then((res) => {
      successToast(res.data?.message);
    })
    .catch((err) => {
      errorToast(err?.response.data?.message);
    });
};

export const paymentVerification = (sessionId, navigate) => {
  ApiCall.post(`/creator/verify-gift-payment?sessionId=${sessionId}`)
    .then((res) => {
      successToast(res.data?.message);
      navigate('/dashboard/create-nft');
    })
    .catch((err) => {
      errorToast(err?.response.data?.message);
      navigate('/dashboard/create-nft');
    });
};

export const setUsernameApi = (username, token, navigate) => {
  publicApiCall
    .patch(
      `/user/set-username`,
      {
        username,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    )
    .then((res) => {
      successToast(res.data?.message);
      // navigate('/dashboard');
    })
    .catch((err) => {
      errorToast(err.response.data?.message);
    });
};

export {
  verifyEmail,
  verifyOtp,
  recoverPassword,
  recoverPasswordUsingEmail,
  resendVerification,
};
